import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { ESignModalComponent } from '../e-sign-modal/e-sign-modal.component';

@Component({
  selector: 'app-offer-detail-modal',
  templateUrl: './offer-detail-modal.component.html',
  styleUrls: ['./offer-detail-modal.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class OfferDetailModalComponent implements OnInit {
  @Input() title!: string;
  @Input() amount!: string;
  @Input() icon!: string;
  @Input() description!: string;

  isMobile = window.innerWidth <= 768;
  isWebView = window.innerWidth > 768;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
  ) { }

  async close() {
    await this.modalCtrl.dismiss();
  }

  async initiateESign() {
    const isDesktop = this.platform.width() > 768;
    await this.modalCtrl.dismiss();
    const modal = await this.modalCtrl.create({
      component: ESignModalComponent,
      cssClass: 'eSignModal',
      handle: false,
      ...(isDesktop
        ? {} // no breakpoints for desktop
        : {
          breakpoints: [0, 0.5, 1],
          initialBreakpoint: 0.5,
        })
    });
    return await modal.present();
  }
  ngOnInit() { }

}
